module.exports = __webpack_public_path__ + "static/media/text-cuotas-bcp-products.7f688c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/text-cuotas-bcp-products.png
// module id = 2259
// module chunks = 0